import React from 'react';
import { useTrans } from 'utils/localisation';
import * as styles from './MandatoryFootnote.module.scss';

export function MandatoryFootnote() {
  const t = useTrans(['corporateForm']);

  return (
    <div className={styles.mandatoryNote}>
      <span className={styles.mandatorySymbol}>*</span>
      {t('mandatoryNote')}
    </div>
  );
}
